<template>
    <div class="tc-modal-delete-alert tc-modal-body">
        <div class="tc-modal-label">
            Удалить шкаф
        </div>
        <div class="tc-modal-text">
            Удалить выбранный шкаф из текущего проекта? После удаления воостановить шкаф будет невозможно.
        </div>
        <div class="tc-modal-two-buttons">
            <OutlineButton :text="'Отмена'"
                           @click="cancel()"/>
            <OrangeButtonOfLawlessness :text="'Удалить'"
                                       @click="deleteCase()"/>
        </div>
    </div>
</template>

<script>
import OutlineButton from '@/UI/CommonComponents/OutlineButton.vue';
import OrangeButtonOfLawlessness from '@/UI/CommonComponents/OrangeButtonOfLawlessness.vue';
import { useStoreUI } from '@/Store/storeUI';
import { useStoreProjectStructure } from '@/Store/storeProjectStructure';
import { deleteCase } from '@/libs/deleteCase';

export default {
    name: 'ModalDeleteCaseAlert',
    components: {
        OrangeButtonOfLawlessness,
        OutlineButton,
    },
    setup() {
        const storeUI = useStoreUI();
        const storeProjectStructure = useStoreProjectStructure();

        return {
            storeUI,
            storeProjectStructure,
        };
    },
    methods: {
        deleteCase() {
            this.storeUI.setIsShowModal(false);
            deleteCase(this.storeProjectStructure.selectedCaseId);
            if (this.storeProjectStructure.cases.length === 0) {
                this.$router.push({ path: '/selectCase' });
            }
        },
        cancel() {
            this.storeUI.setIsShowModal(false);
        },
    },
};
</script>

<style scoped lang="scss">
@import "CSS/modal";

.tc-modal-delete-alert {
    width: 475px;
}

</style>
